type PageMeta = {
  title: string;
  description?: string;
};

function upsertMetaByName(name: string, content: string): void {
    const selector = `meta[name="${name}"]`
    let el = document.head.querySelector<HTMLMetaElement>(selector)

    if (!el) {
        el = document.createElement("meta")
        el.setAttribute("name", name)
        document.head.appendChild(el)
    }

    el.setAttribute("content", content)
}

export function applyPageMeta(meta: PageMeta): void {
    document.title = meta.title

    if (meta.description) {
        upsertMetaByName("description", meta.description)
    }
}
